(function ($) {

    $.fn.pwstrength = function (options) {
        var settings = $.extend({
            enabled: true,
            strength_text: '.pwstrength-text',
            strength_meter: '.pwstrength-meter',
            strength_container: '#pwstrength_container',
            minlength: 6,
            frame: null,
            frametarget: null, // this is the id of the password element within the frame
            texts: ['', 'too weak', 'weak', 'strong'],
            colors: ['', 'red', 'yellow', 'green'],

            medium_regex: '^(((?=.*[a-z])(?=.*[A-Z]))|((?=.*[a-z])(?=.*[0-9]))|((?=.*[A-Z])(?=.*[0-9])))(?=.{6,})',
            strong_regex: '^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})'
        }, options);

        var elem = this;

        var $strength_meter = settings.strength_meter ? $(settings.strength_meter) : null;

        var $strength_text = settings.strength_text ? $(settings.strength_text) : null;

        var $strength_container = settings.strength_container ? $(settings.strength_container) : null;

        var strengthtext_class = $strength_text.attr('class');

        // handle the case of passsword strength within an iframe
        // frame and frametarget must be defined
        if (settings.frame && settings.frametarget) {
            var $framecont = $(settings.frame).contents();
            elem = $(settings.frametarget, $framecont);
            $strength_meter = $(settings.strength_meter, $framecont);
            $strength_text = $(settings.strength_text, $framecont);
            $strength_container = $(settings.strength_container, $framecont);
        }

        if (settings.enabled) {
            $strength_meter.show();
            $strength_text.show();
            elem.addClass('pwstrength-input');
        } else {
            $strength_meter.hide();
            $strength_text.hide();
        } 

        elem.on('keyup.pwstr change', function () {
            if (settings.enabled) {
                var val = elem.val();
                var strength = getStrength(val, settings.minlength, settings.medium_regex, settings.strong_regex);

                $('#pwstrengthvalue').val(strength).change();

                if (val.length > 0) {
                    var strength_text_class = strengthtext_class + ' ' + settings.colors[strength],
                        strength_meter_class = 'pwstrength-meter ' + settings.colors[strength];

                    if (!$strength_text.hasClass(strength_text_class) && strength in settings.texts)
                        $strength_text.text(settings.texts[strength]).attr('class', strength_text_class);

                    if ($strength_meter)
                        $strength_meter.attr('class', strength_meter_class);

                    if (!$strength_container.hasClass('pwstrength-container'))
                            $strength_container.addClass('pwstrength-container');

                } else {
                    $strength_text.text('').attr('class', strengthtext_class);

                    if($strength_container.hasClass('pwstrength-container'))
                            $strength_container.removeClass('pwstrength-container');

                    if ($strength_meter)
                        $strength_meter.attr('class', 'pwstrength-meter');

                }
            }
        });

        var STRENGTH_LEVEL = {
            NONE: 0,
            TOO_WEAK: 1,
            WEAK: 2,
            STRONG: 3
        };

        var getStrength = function (val, minlength, medrgx, strrgx) {
            var strength = STRENGTH_LEVEL.TOO_WEAK;
            if (val.length < minlength)
                strength = STRENGTH_LEVEL.NONE;

            if (val.match(new RegExp(medrgx)))
                strength = STRENGTH_LEVEL.WEAK;

            if (val.match(new RegExp(strrgx)))
                strength = STRENGTH_LEVEL.STRONG;

            return strength;
        }

    };

}(jQuery));
